import React from "react";
import { useTranslation } from "react-i18next";
import {
    Box,
    Grid,
    Typography,
} from "@material-ui/core";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { deleteInvoiceCutting, fetchInvoiceCuttings } from "redux/actions/invoices";
import InvoiceCuttingDialog from "components/InvoiceCuttingDialog";
import ConfirmDialog from "components/ConfirmDialog";
import { toast } from "react-toastify";
import useStyles from "./style";
import InvoiceCuttingCard from "./InvoiceCuttingCard";


function InvoiceCutting() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [selected, setSelected] = React.useState(null);
    const data = useSelector(({ requests }) =>
        get(requests, "queries.FETCH_INVOICE_CUTTINGS.data")
    );
    const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
    const [isDeleting, setIsDeleting] = React.useState(false);
    const [idToDelete, setIdToDelete] = React.useState(null);

    React.useEffect(() => {
        dispatch(fetchInvoiceCuttings());
    }, []);

    React.useEffect(() => {
        if (selected && data) {
            const updated = data.find(i => i.id === selected.id);
            if (!updated) {
                setSelected(null);
            } else if (selected.status !== updated.status) {
                setSelected(updated);
            }
        }
    }, [data]);

    const askDelete = (id) => {
        setIdToDelete(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        setIsDeleting(true);
        dispatch(deleteInvoiceCutting(idToDelete, () => {
            dispatch(fetchInvoiceCuttings());
        })).then(() => {
            setDeleteConfirmOpen(false);
            setIsDeleting(false);
            toast.success(t("invoiceCutting.deletionSuccess"));
        }).catch(() => {
            setIsDeleting(false)
            toast.error(t("invoiceCutting.deletionError"));
        });
    };

    const openItem = (item) => {
        setSelected(item);
        setDialogOpen(true);
    };

    // This is used instead of (data?.length === 0) to handle when data is null.
    if (!data?.length > 0) return <></>;

    return (
        <Grid item xs={12}>
            <Box className={classes.titleBox}>
                <Typography variant="subtitle2" color="primary" display="inline"> {t("invoiceCutting.title")} </Typography>
            </Box>
            <Grid container className={classes.container}>
                {
                    data?.map(item => (
                        <Grid key={item.id} item xs={4}>
                            <InvoiceCuttingCard
                                invoiceCutting={item}
                                onOpen={() => openItem(item)}
                                onDelete={() => askDelete(item.id)}
                            />
                        </Grid>
                    ))
                }
            </Grid>

            <InvoiceCuttingDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                invoiceCutting={selected}
            />

            <ConfirmDialog
                message={t("invoiceCutting.confirmation.delete")}
                open={deleteConfirmOpen}
                isLoading={isDeleting}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteConfirmOpen(false)}
            />
        </Grid>
    );
}

export default InvoiceCutting;